import React from "react";
import { CellUserModalName, CellUserModalSolution, CellUserModalRoles, CellUserModalActions } from "../../../common/cell.component";
import TableView from "../../../../../Basic/TableView";

var AddUserTable = function AddUserTable(props) {
  var data = props.data,
      formData = props.formData,
      prefix = props.prefix,
      translate = props.translate,
      editFormUser = props.editFormUser,
      deleteFormUser = props.deleteFormUser;
  var columns = [{
    id: "Name",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserTableNameTitle'),
    headerStyle: {
      minWidth: 170
    },
    style: {
      minWidth: 170
    },
    minWidth: 170,
    Cell: function Cell(row) {
      return /*#__PURE__*/React.createElement(CellUserModalName, {
        row: row
      });
    }
  }, {
    id: "SolutionsAndRoles",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserTableRoleTitle'),
    headerStyle: {
      minWidth: 170
    },
    style: {
      minWidth: 170
    },
    minWidth: 170,
    Cell: function Cell(row) {
      return /*#__PURE__*/React.createElement(CellUserModalSolution, {
        row: row
      });
    }
  }, {
    id: "SFxRole",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserTableSFxRoleTitle'),
    headerStyle: {
      minWidth: 160
    },
    style: {
      minWidth: 160
    },
    minWidth: 160,
    Cell: function Cell(row) {
      return /*#__PURE__*/React.createElement(CellUserModalRoles, {
        row: row
      });
    }
  }, {
    id: "_actions",
    Header: "",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    headerStyle: {
      minWidth: 70
    },
    style: {
      minWidth: 70
    },
    minWidth: 70,
    className: "disable-resize",
    headerClassName: "disable-resize",
    Cell: function Cell(row) {
      return /*#__PURE__*/React.createElement(CellUserModalActions, {
        row: row,
        formUser: formData,
        editFormUser: editFormUser,
        deleteFormUser: deleteFormUser
      });
    }
  }];
  return /*#__PURE__*/React.createElement(TableView, {
    className: "".concat(prefix, "-user-modal-table"),
    data: data,
    columns: columns,
    showPagination: false
  });
};

export default AddUserTable;